import type { KeybindingShortcut, ResolvedKeybindingsConfig } from "@cmmd-forge/contracts";
import { DEFAULT_RESOLVED_KEYBINDINGS } from "@cmmd-forge/shared/keybindings";
import { resolveShortcutCommand, type ShortcutEventLike } from "./keybindings";
import { isMacPlatform } from "./lib/utils";

const SHORTCUT_PLATFORMS = ["MacIntel", "Linux"] as const;

function shortcutEvent(shortcut: KeybindingShortcut, platform: string): ShortcutEventLike {
  const mac = isMacPlatform(platform);
  return {
    key: shortcut.key,
    metaKey: shortcut.metaKey || (shortcut.modKey && mac),
    ctrlKey: shortcut.ctrlKey || (shortcut.modKey && !mac),
    shiftKey: shortcut.shiftKey,
    altKey: shortcut.altKey,
  };
}

function isClaimedOnAnyPlatform(
  keybindings: ResolvedKeybindingsConfig,
  shortcut: KeybindingShortcut,
): boolean {
  return SHORTCUT_PLATFORMS.some(
    (platform) =>
      resolveShortcutCommand(shortcutEvent(shortcut, platform), keybindings, {
        platform,
        context: { terminalFocus: false, terminalOpen: false },
      }) !== null,
  );
}

/** Adds the stash default when an older server snapshot has no competing shortcut. */
export function withComposerStashDefault(
  keybindings: ResolvedKeybindingsConfig,
): ResolvedKeybindingsConfig {
  if (keybindings.some((binding) => binding.command === "composer.stash")) return keybindings;

  const defaultBinding = DEFAULT_RESOLVED_KEYBINDINGS.find(
    (binding) => binding.command === "composer.stash",
  );
  if (!defaultBinding) return keybindings;
  if (isClaimedOnAnyPlatform(keybindings, defaultBinding.shortcut)) {
    return keybindings;
  }
  return [...keybindings, defaultBinding];
}
